export default "<p>board-admin works!</p>\n"